export default [
  {
    path: '/courseDetail',
    name: 'courseDetail',
    component: () => import('@/views/course/Detail.vue'),
    meta: { title: '课堂详情', customWechatShare: true, pageLevel: 3 }
  },
  {
    path: '/courseSearch',
    name: 'courseSearch',
    component: () => import('@/views/course/CourseSearch.vue'),
    meta: { title: '课堂搜索' }
  }
]
